import featureFlagService from "@/utils/FeatureFlagService";

export default {
  install(app) {
    const featureFlags = {};

    // Add a global $features object to your Vue app
    app.config.globalProperties.$features = featureFlags;

    // Provide feature flags to all components
    app.provide("features", featureFlags);

    // Method to load all feature flags
    app.config.globalProperties.$loadFeatures = async function (flagNames) {
      const loaded = await featureFlagService.getFeatureFlags(flagNames);
      Object.assign(featureFlags, loaded);
      return featureFlags;
    };
  },
};
